type PwaRegistration = {
  update(): Promise<void>;
};

type ServiceWorkerRegistrar = {
  register(scriptURL: string, options?: RegistrationOptions): Promise<PwaRegistration>;
};

type RegisterPwaOptions = {
  enabled?: boolean;
  serviceWorker?: ServiceWorkerRegistrar | null;
};

export async function registerPwa({
  enabled = import.meta.env.PROD,
  serviceWorker,
}: RegisterPwaOptions = {}) {
  if (!enabled) return null;

  const registrar = serviceWorker === undefined
    ? typeof navigator !== "undefined" && "serviceWorker" in navigator
      ? navigator.serviceWorker
      : null
    : serviceWorker;

  if (!registrar) return null;

  const registration = await registrar.register("/sw.js", {
    scope: "/",
    updateViaCache: "none",
  });
  await registration.update();
  return registration;
}

let registrationScheduled = false;

export function setupPwaRegistration() {
  if (registrationScheduled || typeof window === "undefined") return;
  registrationScheduled = true;

  const start = () => {
    void registerPwa().catch(() => {
      // A indisponibilidade do worker não pode bloquear login ou uso do OS.
    });
  };

  if (document.readyState === "complete") start();
  else window.addEventListener("load", start, { once: true });
}
